/**
 * CR-7781: a call-off's status badge, plus Logistics Confirmed once the
 * haulier has confirmed the load — two separate indicators, because they are
 * two separate confirmations by two different companies.
 *
 * @link callOffStatus for the labels and colours.
 */
import { Badge } from '../ui/badge';
import { CALL_OFF_STATUS_META, LOGISTICS_CONFIRMED_META, callOffStatusLabel } from './callOffStatus';

interface CallOffStatusBadgesProps {
  status: string;
  /** The call-off's `logistics_confirmed_at`; the second badge shows when set. */
  logisticsConfirmedAt?: string | null;
}

export default function CallOffStatusBadges({ status, logisticsConfirmedAt }: CallOffStatusBadgesProps) {
  const meta = CALL_OFF_STATUS_META[status];
  return (
    <>
      {meta ? (
        <Badge variant="secondary" className={meta.className}>{meta.label}</Badge>
      ) : (
        <Badge variant="outline">{callOffStatusLabel(status)}</Badge>
      )}
      {logisticsConfirmedAt && (
        <Badge variant="secondary" className={LOGISTICS_CONFIRMED_META.className}>
          {LOGISTICS_CONFIRMED_META.label}
        </Badge>
      )}
    </>
  );
}
